import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ColumnFilter} from '../column-filters.service';

@Component({
  selector: 'asax-result-table-column-filter',
  templateUrl: './column-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./column-filter.component.scss']
})
export class ColumnFilterComponent {
  @Input() columnFilter: ColumnFilter;
  @Input() isFirst: boolean;

  @Output() outColumnFilter = new EventEmitter<ColumnFilter>();
  @Output() outRemoveColumnFilter = new EventEmitter<string>();

  label: string;
  isHovered: boolean = false;

  removeColumnFilter(): void {
    this.outRemoveColumnFilter.emit(this.columnFilter.id);
  }

  toggleColumnFilterIsDisable(): void {
    this.columnFilter = {...this.columnFilter, isDisabled: !this.columnFilter.isDisabled};
    this.outColumnFilter.emit(this.columnFilter);
  }

  getTooltipText(): string {
    return this.columnFilter.isDisabled ? "Enable filter" : "Disable filter";
  }
}
